<template>
  <div class="no-set-object">
    <h3>{{ $t("no_object_title") }}</h3>
    <ul>
      <li v-for="(item, index) in noObjectInfo" :key="index" v-html="item"></li>
    </ul>

    <h4>{{ $t("no_object_filter_title") }}</h4>
    <ul>
      <li
        v-for="(item, index) in noObjectFilterInfo"
        :key="index"
        v-html="item"
      ></li>
    </ul>

    <h4>{{ $t("no_object_list_title") }}</h4>
    <ul>
      <li
        v-for="(item, index) in noObjectListInfo"
        :key="index"
        v-html="item"
      ></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "NoSetObject",
  data() {
    return {};
  },
  computed: {
    noObjectInfo() {
      return [
        this.$t("no_object_1"),
        this.$t("no_object_2"),
        this.$t("no_object_3")
      ];
    },
    noObjectFilterInfo() {
      return [
        this.$t("no_object_filter_1"),
        this.$t("no_object_filter_2"),
        this.$t("no_object_filter_3"),
        this.$t("no_object_filter_4")
      ];
    },
    noObjectListInfo() {
      return [this.$t("no_object_list_1"), this.$t("no_object_list_2")];
    }
  },
  methods: {}
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

.no-set-object {
  margin: 10px 15px;
  font-size: $main_font_size;
  text-align: justify;

  ul {
    margin-left: 40px;
  }

  h4 {
    padding-top: $element_padding_on_top;
  }
}
</style>
